module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-switch', {
    staticClass: "compact",
    attrs: {
      "color": "primary",
      "input-value": _vm.value,
      "label": _vm.schema.label,
      "hide-details": false,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder,
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1021b610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/controls/SwitchControl.vue
// module id = 2451
// module chunks = 1